import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history';
import { reactAI } from "react-appinsights";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
import App from './App';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

//Add ApplicationInsights tracing to React
let appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: "d899691d-6c7d-492a-b9db-a47453b91e82",
        extensions: [reactAI],
        extensionConfig: {
            [reactAI.extensionId]: { history: history }
        }
    }
});
appInsights.loadAppInsights();


// Get the application-wide store instance, prepopulating with state from the server where available.
const store = createStore(rootReducer(history), compose(
    applyMiddleware(routerMiddleware(history), thunk, logger),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
));

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);